
// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// const Gallery = () => {
//   const [activeCategory, setActiveCategory] = useState('ALL');

//   // Define images with their categories
//   const allImages = [
//     // Training images
//     { src: "photo8.jpg", category: "TRAINING" },
//     { src: "photo18.jpg", category: "TRAINING" },
//     { src: "photo19.jpg", category: "TRAINING" },
//     { src: "photo20.jpg", category: "TRAINING" },
//     { src: "Photo21.jpeg", category: "TRAINING" },

//     // Trips
//     { src: "photo7.jpg", category: "TRIPS" },
//     { src: "photo9.jpg", category: "TRIPS" },
//     { src: "photo10.jpg", category: "TRIPS" },
//     { src: "photo11.jpg", category: "TRIPS" },
//     { src: "photo12.jpg", category: "TRIPS" },
//     { src: "photo22.jpeg", category: "TRIPS" },

//     // Events
//     { src: "photo1.jpg", category: "EVENTS" },
//     { src: "photo2.jpg", category: "EVENTS" },
//     { src: "photo3.jpg", category: "EVENTS" },
//     { src: "photo4.jpg", category: "EVENTS" },
//     { src: "photo5.jpg", category: "EVENTS" },
//     { src: "photo6.jpg", category: "EVENTS" },
//     { src: "photo13.jpg", category: "EVENTS" },
//     { src: "photo14.jpg", category: "EVENTS" },
//     { src: "photo15.jpg", category: "EVENTS" },
//     { src: "photo16.jpg", category: "EVENTS" },
//     { src: "photo17.jpg", category: "EVENTS" },
//     { src: "photo23.jpeg", category: "EVENTS" },
//     { src: "photo24.jpeg", category: "EVENTS" },
//     { src: "photo25.jpeg", category: "EVENTS" },
//     { src: "photo26.jpeg", category: "EVENTS" },
//     { src: "photo27.jpeg", category: "EVENTS" },
//     { src: "photo28.jpeg", category: "EVENTS" },
//     { src: "photo29.jpeg", category: "EVENTS" },
//     // { src: "photo30.jpeg", category: "EVENTS" },
//   ];

//   const filteredImages = activeCategory === 'ALL'
//     ? allImages
//     : allImages.filter(img => img.category === activeCategory);

//   const categories = ['ALL', 'EVENTS', 'TRIPS', 'TRAINING'];

//   return (
//     <div className="gallery-wrapper">
//       {/* Header Section */}
//       <div className="gallery-header" >
//         <div className="get-to-know">
//           <span>✦</span> GET TO KNOW US <span>✦</span>
//         </div>
//         <h1 className="main-title">
//           We Exist To Help Your Business <br />
//           (Re)define Success
//         </h1>
//         <p className="sub-description">
//           We are not just an IT company; we are your strategic partner in
//           navigating the ever-evolving world of technology.
//         </p>
//         <Link to="/" className="home-btn">
//           Take me to home <span>↗</span>
//         </Link>
//       </div>

//       {/* Main Full Team Photo */}
//       <div className="full-img-container">
//         <img src="/assets/img/Gallery/G1.jpeg" alt="Galaxy Team" />
//         <div className="img-overlay"></div>
//         <div className="logo-overlay">
//           <h2 className="logo-text">GALAXYERP</h2>
//           <p className="logo-subtext">SOFTWARE</p>
//         </div>
//       </div>

//       {/* Simple Underline Category Filter */}
//       <div className="underline-filter-section">
//         <div className="underline-tabs">
//           {categories.map((category) => (
//             <button
//               key={category}
//               onClick={() => setActiveCategory(category)}
//               className={`underline-tab ${activeCategory === category ? 'tab-active' : ''}`}
//             >
//               {category}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Gallery Grid */}
//       <div className="gallery-container">
//         <div className="gallery-grid">
//           {filteredImages.map((img, index) => (
//             <div className="gallery-card" key={index}>
//               <div className="image-box1">
//                 <img
//                   src={`/assets/img/Gallery/${img.src}`}
//                   alt={`Gallery item ${index + 1}`}
//                   loading="lazy"
//                 />
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Gallery;

// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';

// const Gallery = () => {
//   const [activeCategory, setActiveCategory] = useState('ALL');
//   const gridRef = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add('card-visible');
//           }
//         });
//       },
//       { threshold: 0.05 }
//     );

//     const cards = gridRef.current?.querySelectorAll('.gallery-card');
//     cards?.forEach((card) => {
//       card.classList.remove('card-visible');
//       observer.observe(card);
//     });

//     return () => observer.disconnect();
//   }, [activeCategory]);

//   const allImages = [
//     { src: "photo8.jpg",   category: "TRAINING" },
//     { src: "photo18.jpg",  category: "TRAINING" },
//     { src: "photo19.jpg",  category: "TRAINING" },
//     { src: "photo20.jpg",  category: "TRAINING" },
//     { src: "Photo21.jpeg", category: "TRAINING" },
//     { src: "photo7.jpg",   category: "TRIPS" },
//     { src: "photo9.jpg",   category: "TRIPS" },
//     { src: "photo10.jpg",  category: "TRIPS" },
//     { src: "photo11.jpg",  category: "TRIPS" },
//     { src: "photo12.jpg",  category: "TRIPS" },
//     { src: "photo22.jpeg", category: "TRIPS" },
//     { src: "photo1.jpg",   category: "EVENTS" },
//     { src: "photo2.jpg",   category: "EVENTS" },
//     { src: "photo3.jpg",   category: "EVENTS" },
//     { src: "photo4.jpg",   category: "EVENTS" },
//     { src: "photo5.jpg",   category: "EVENTS" },
//     { src: "photo6.jpg",   category: "EVENTS" },
//     { src: "photo13.jpg",  category: "EVENTS" },
//     { src: "photo14.jpg",  category: "EVENTS" },
//     { src: "photo15.jpg",  category: "EVENTS" },
//     { src: "photo16.jpg",  category: "EVENTS" },
//     { src: "photo17.jpg",  category: "EVENTS" },
//     { src: "photo23.jpeg", category: "EVENTS" },
//     { src: "photo24.jpeg", category: "EVENTS" },
//     { src: "photo25.jpeg", category: "EVENTS" },
//     { src: "photo26.jpeg", category: "EVENTS" },
//     { src: "photo27.jpeg", category: "EVENTS" },
//     { src: "photo28.jpeg", category: "EVENTS" },
//     { src: "photo29.jpeg", category: "EVENTS" },
//   ];

//   const filteredImages = activeCategory === 'ALL'
//     ? allImages
//     : allImages.filter(img => img.category === activeCategory);

//   const categories = ['ALL', 'EVENTS', 'TRIPS', 'TRAINING'];

//   return (
//     <div className="gallery-wrapper">

//       <div className="gallery-header">
//         <div className="get-to-know">
//           <span>✦</span> GET TO KNOW US <span>✦</span>
//         </div>
//         <h1 className="main-title">
//           We Exist To Help Your Business <br />
//           (Re)define Success
//         </h1>
//         <p className="sub-description">
//           We are not just an IT company; we are your strategic partner in
//           navigating the ever-evolving world of technology.
//         </p>
//         <Link to="/" className="home-btn">
//           Take me to home <span>↗</span>
//         </Link>
//       </div>

//       <div className="full-img-container" data-aos="fade-up">
//         <img src="/assets/img/Gallery/G1.jpeg" alt="Galaxy Team" />
//         <div className="img-overlay"></div>
//         <div className="logo-overlay">
//           <h2 className="logo-text">GALAXYERP</h2>
//           <p className="logo-subtext">SOFTWARE</p>
//         </div>
//       </div>

//       <div className="underline-filter-section">
//         <div className="underline-tabs">
//           {categories.map((category) => (
//             <button
//               key={category}
//               onClick={() => setActiveCategory(category)}
//               className={`underline-tab ${activeCategory === category ? 'tab-active' : ''}`}
//             >
//               {category}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="gallery-container">
//         <div className="gallery-grid" ref={gridRef}>
//           {filteredImages.map((img, index) => (
//             <div
//               className="gallery-card"
//               key={index}
//           style={{ transitionDelay: `${index * 60}ms` }}
//             >
//               <div className="image-box1">
//                 <img
//                   src={`/assets/img/Gallery/${img.src}`}
//                   alt={`Gallery item ${index + 1}`}
//                   loading="lazy"
//                 />
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//     </div>
//   );
// };

// export default Gallery;


/*popup*/
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState('ALL');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const gridRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('card-visible');
          }
        });
      },
      { threshold: 0.05 }
    );

    const cards = gridRef.current?.querySelectorAll('.gallery-card');
    cards?.forEach((card) => {
      card.classList.remove('card-visible');
      observer.observe(card);
    });

    return () => observer.disconnect();
  }, [activeCategory]);

  const allImages = [
    { src: "photo8.jpg",   category: "TRAINING" },
    { src: "photo18.jpg",  category: "TRAINING" },
    { src: "photo19.jpg",  category: "TRAINING" },
    { src: "photo20.jpg",  category: "TRAINING" },
    { src: "Photo21.jpeg", category: "TRAINING" },
    { src: "photo7.jpg",   category: "TRIPS" },
    { src: "photo9.jpg",   category: "TRIPS" },
    { src: "photo10.jpg",  category: "TRIPS" },
    { src: "photo11.jpg",  category: "TRIPS" },
    { src: "photo12.jpg",  category: "TRIPS" },
    { src: "photo22.jpeg", category: "TRIPS" },
    { src: "photo28.jpeg", category: "EVENTS" },
    { src: "photo1.jpg",   category: "EVENTS" },
    { src: "photo2.jpg",   category: "EVENTS" },
    { src: "photo3.jpg",   category: "EVENTS" },
    { src: "photo4.jpg",   category: "EVENTS" },
    { src: "photo5.jpg",   category: "EVENTS" },
    { src: "photo6.jpg",   category: "EVENTS" },
    { src: "photo13.jpg",  category: "EVENTS" },
    { src: "photo14.jpg",  category: "EVENTS" },
    { src: "photo15.jpg",  category: "EVENTS" },
    { src: "photo16.jpg",  category: "EVENTS" },
    { src: "photo17.jpg",  category: "EVENTS" },
    { src: "photo23.jpeg", category: "EVENTS" },
    { src: "photo24.jpeg", category: "EVENTS" },
    { src: "photo25.jpeg", category: "EVENTS" },
    { src: "photo26.jpeg", category: "EVENTS" },
    { src: "photo27.jpeg", category: "EVENTS" },
  
    // { src: "photo29.jpeg", category: "EVENTS" },
  ];

  const filteredImages = activeCategory === 'ALL'
    ? allImages
    : allImages.filter(img => img.category === activeCategory);

  const categories = ['ALL', 'EVENTS', 'TRIPS', 'TRAINING'];

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % filteredImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + filteredImages.length) % filteredImages.length);
  };

  // Keyboard navigation + ESC
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!lightboxOpen) return;
      
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowRight') {
        nextImage();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      }
    };
    
    if (lightboxOpen) {
      window.addEventListener('keydown', handleKeyPress);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      document.body.style.overflow = 'unset';
    };
  }, [lightboxOpen, currentImageIndex, filteredImages.length]);

  return (
    <div className="gallery-wrapper">

      <div className="gallery-header">
        <div className="get-to-know">
          <span>✦</span> GET TO KNOW US <span>✦</span>
        </div>
        <h1 className="main-title">
          We Exist To Help Your Business <br />
          (Re)define Success
        </h1>
        <p className="sub-description">
          We are not just an IT company; we are your strategic partner in
          navigating the ever-evolving world of technology.
        </p>
        <Link to="/" className="home-btn">
          Take me to home <span>↗</span>
        </Link>
      </div>

      <div className="full-img-container">
        <img src="/assets/img/Gallery/G1.jpeg" alt="Galaxy Team" />
        <div className="logo-overlay">
          <h2 className="logo-text">GALAXYERP</h2>
          <p className="logo-subtext">SOFTWARE</p>
        </div>
      </div>

      <div className="underline-filter-section">
        <div className="underline-tabs">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`underline-tab ${activeCategory === category ? 'tab-active' : ''}`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="gallery-container">
        <div className="gallery-grid" ref={gridRef}>
          {filteredImages.map((img, index) => (
            <div
              className="gallery-card"
              key={index}
              style={{ transitionDelay: `${index * 60}ms` }}
              onClick={() => openLightbox(index)}
            >
              <div className="image-box1">
                <img
                  src={`/assets/img/Gallery/${img.src}`}
                  alt={`Gallery ${index + 1}`}
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ════════════════════════════════════════
          PROFESSIONAL LIGHTBOX
          Big IT Company Style
          ════════════════════════════════════════ */}
      {lightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          
          {/* Close Button - Top Right */}
          <button className="lightbox-close" onClick={closeLightbox} aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>

          {/* Image Container */}
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            
            {/* Main Image */}
            <div className="lightbox-image-wrapper">
              <img
                src={`/assets/img/Gallery/${filteredImages[currentImageIndex].src}`}
                alt={`Gallery ${currentImageIndex + 1}`}
                className="lightbox-image"
              />
            </div>

            {/* Bottom Controls Bar */}
            <div className="lightbox-controls">
              
              {/* Previous Button */}
              <button 
                className="lightbox-nav-btn" 
                onClick={prevImage}
                aria-label="Previous image"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <polyline points="15 18 9 12 15 6"/>
                </svg>
              </button>

              {/* Counter */}
              <div className="lightbox-counter">
                {currentImageIndex + 1} / {filteredImages.length}
              </div>

              {/* Next Button */}
              <button 
                className="lightbox-nav-btn" 
                onClick={nextImage}
                aria-label="Next image"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </button>

            </div>

          </div>

        </div>
      )}

    </div>
  );
};

export default Gallery;